import script from "./PromoteClassModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoteClassModal.vue?vue&type=script&setup=true&lang=js"

import "./PromoteClassModal.vue?vue&type=style&index=0&id=44b45886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b45886"]])

export default __exports__